import { ClassUtils } from "../utils/ClassUtils";
import { AutoBitmap } from "./AutoBitmap";
import { Box } from "./Box";
import { Button } from "./Button";
import { CheckBox } from "./CheckBox";
import { Clip } from "./Clip";
import { ColorPicker } from "./ColorPicker";
import { ComboBox } from "./ComboBox";
import { Dialog } from "./Dialog";
import { DialogManager } from "./DialogManager";
import { FontClip } from "./FontClip";
import { HBox } from "./HBox";
import { HScrollBar } from "./HScrollBar";
import { HSlider } from "./HSlider";
import { Image } from "./Image";
import { Label } from "./Label";
import { LayoutBox } from "./LayoutBox";
import { List } from "./List";
import { Panel } from "./Panel";
import { ProgressBar } from "./ProgressBar";
import { Radio } from "./Radio";
import { RadioGroup } from "./RadioGroup";
import { ScaleBox } from "./ScaleBox";
import { ScrollBar } from "./ScrollBar";
import { Slider } from "./Slider";
import { Tab } from "./Tab";
import { TextArea } from "./TextArea";
import { TextInput } from "./TextInput";
import { TipManager } from "./TipManager";
import { Tree } from "./Tree";
import { UIComponent } from "./UIComponent";
import { UIGroup } from "./UIGroup";
import { UIUtils } from "./UIUtils";
import { VBox } from "./VBox";
import { View } from "./View";
import { ViewStack } from "./ViewStack";
import { VScrollBar } from "./VScrollBar";
import { VSlider } from "./VSlider";
let c = ClassUtils.regClass;
c("AutoBitmap", AutoBitmap);
c("Box", Box);
c("Button", Button);
c("CheckBox", CheckBox);
c("Clip", Clip);
c("ColorPicker", ColorPicker);
c("ComboBox", ComboBox);
c("Dialog", Dialog);
c("DialogManager", DialogManager);
c("FontClip", FontClip);
c("HBox", HBox);
c("HScrollBar", HScrollBar);
c("HSlider", HSlider);
c("Image", Image);
c("Label", Label);
c("LayoutBox", LayoutBox);
c("List", List);
c("Panel", Panel);
c("ProgressBar", ProgressBar);
c("Radio", Radio);
c("RadioGroup", RadioGroup);
c("ScaleBox", ScaleBox);
c("ScrollBar", ScrollBar);
c("Slider", Slider);
c("Tab", Tab);
c("TextArea", TextArea);
c("TextInput", TextInput);
c("TipManager", TipManager);
c("Tree", Tree);
c("UIGroup", UIGroup);
c("UIUtils", UIUtils);
c("VBox", VBox);
c("View", View);
c("ViewStack", ViewStack);
c("VScrollBar", VScrollBar);
c("VSlider", VSlider);
c("UIComponent", UIComponent);
